import { createSlice } from "@reduxjs/toolkit";
import { disable2FA, forgotPassword, initiateFacebookLogin, loginUser, registerUser, reqResetPassword, twoFaSetup, twoFaVerify, userProfile, userProfileedit, verifyOtp } from "./userThunk";
import { toast } from "react-toastify";

const initialState = {
  user: null,
  profile: null,
  loading: false,
  lgerror: null,
  rgerror: null,
  error: null,
  Verifyerror: null,
  isAuthenticated: false,
  isRegisterAuthenticated: false,
  editprofile: null,
  token: null,
  verificationStatus: null,
  twoFa: null,
  disableStatus: null,
  email: '',
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    resertloginerrer: (state) => {
      state.lgerror = null;
    },
    storeEmail(state, action) {
      state.email = action.payload;
    },
    resetAuth: (state) => {
      state.isAuthenticated = false;
    },
    registerResetAuth: (state) => {
      state.isRegisterAuthenticated = false;
      state.rgerror = null;

    },
    resetverificationStatus: (state) => {
      state.verificationStatus = null;
      state.Verifyerror = null;
    },
    resetProfile: (state) => {
      state.profile = null
    },
    reseteditProfile: (state) => {
      state.editprofile = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.lgerror = null;
        state.isAuthenticated = false;
        // toast.loading('login....')

      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload;
        state.lgerror = null
        state.isAuthenticated = true;
          toast.success("Login Successfull");

      })
      .addCase(loginUser.rejected, (state, action) => {
      toast.error(action.payload)  
        state.loading = false;
        state.lgerror = action.payload;
        state.isAuthenticated = false;

      })
      .addCase(registerUser.pending, (state) => {
        state.isRegisterAuthenticated = false;
        state.loading = true;
        state.rgerror = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
          toast.success("OTP sent to your email.");
        state.loading = false;
        state.isRegisterAuthenticated = true;
        // state.user = action.payload;
        state.token = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
           toast.error(action.payload || "Registration failed");
        state.isRegisterAuthenticated = false;
        state.loading = false;
        state.rgerror = action.payload;
      })
            .addCase(initiateFacebookLogin.pending, (state) => {
        state.fbLoginLoading = true;
        state.fbLoginError = null;
      })
      .addCase(initiateFacebookLogin.fulfilled, (state) => {
        state.fbLoginLoading = false;
      })
      .addCase(initiateFacebookLogin.rejected, (state, action) => {
        state.fbLoginLoading = false;
        state.fbLoginError = action.payload || "Unknown error";
      })
      .addCase(userProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profile = action.payload;
      })
      .addCase(userProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(reqResetPassword.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(reqResetPassword.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
        state.error = null;
      })
      .addCase(reqResetPassword.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })
      .addCase(userProfileedit.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(userProfileedit.fulfilled, (state, action) => {
        state.loading = false;
        state.editprofile = action.payload;
        state.error = null;
      })
      .addCase(userProfileedit.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      })

      .addCase(forgotPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgotPassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(twoFaSetup.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(twoFaSetup.fulfilled, (state, action) => {
        state.loading = false;
        state.twoFa = action.payload;
      })
      .addCase(twoFaSetup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(twoFaVerify.pending, (state) => {
        state.loading = true;
        state.Verifyerror = null;
      })
      .addCase(twoFaVerify.fulfilled, (state, action) => {
        state.loading = false;
        state.verificationStatus = action.payload;
      })
      .addCase(twoFaVerify.rejected, (state, action) => {
        state.loading = false;
        state.Verifyerror = action.payload;
      }).addCase(disable2FA.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(disable2FA.fulfilled, (state, action) => {
        state.loading = false;
        state.disableStatus = action.payload;
      })
      .addCase(disable2FA.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(verifyOtp.pending, (state) => {
        // state.loading = true;
        // state.error = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
      toast.success(action.payload.message)
      
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        toast.error(action.payload.message)
      })
  },
});

export const { logout, resetAuth, registerResetAuth, resetverificationStatus, resetProfile, reseteditProfile, resertloginerrer, storeEmail } = userSlice.actions;
export default userSlice.reducer;
